module.exports = __webpack_public_path__ + "a7da67eaca639e97b6667245852f9c34.MP3";